export default __webpack_public_path__ + "static/media/support_platform_mall2.bfea072b.png";